import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import styles from './styles.module.scss';

const GroupNotesUpdatetime = () => {
    const { UpDateTime } = useSelector((state: RootState) => state.itinerariesReducer);

    return <div className={styles.container}>{UpDateTime} 更新</div>;
};

export default GroupNotesUpdatetime;
